import nullGuardLogo from "@/assets/null-guard-logo.svg";
import incibeLogo from "@/assets/incibe-emprende.png";

const Footer = () => {
  return (
    <footer className="border-t border-border bg-card/50 px-4 py-12" role="contentinfo">
      <div className="container mx-auto">
        <div className="flex flex-col items-center gap-8 md:flex-row md:justify-between">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2">
            <img src={nullGuardLogo} alt="Null Guard — Inicio" className="h-10 w-auto" width={40} height={40} />
          </a>

          {/* Badges */}
          <div className="flex flex-wrap items-center justify-center gap-6">
            <a href="https://www.incibe.es/incibe-emprende" target="_blank" rel="noopener noreferrer">
              <img src={incibeLogo} alt="Sello INCIBE Emprende — visitar INCIBE" className="h-20 w-auto" width={80} height={80} loading="lazy" />
            </a>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center gap-4 border-t border-border pt-8 text-sm text-muted-foreground md:flex-row md:justify-between">
          <p>© {new Date().getFullYear()} Null Guard. Todos los derechos reservados.</p>
          <nav aria-label="Enlaces legales" className="flex gap-4">
            <a href="/aviso-legal" className="underline transition-colors hover:text-foreground">Aviso legal</a>
            <a href="/politica-de-privacidad" className="underline transition-colors hover:text-foreground">Política de privacidad</a>
            <a href="/accesibilidad" className="underline transition-colors hover:text-foreground">Accesibilidad</a>
            <a href="mailto:info@nullguard.xyz" className="underline transition-colors hover:text-foreground">Contacto</a>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
